import { useLocation, useParams } from "react-router-dom";
import { OrderSummaryMain } from "../OrderSummary/OrderSummaryMain";
import { OrderStatusDetail } from "./orderDetailMain";
import { OrderStatusGreeting } from "./greetingContainer";
import { useAuth } from "../../Context/AuthContext";
import { Fragment, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { GlobalContext } from "../../Context/GlobalContext";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { useNoteAlert } from "../../Context/pleaseNote";
import { Link } from "react-router-dom";
import { OrderConfirmationSkeleton } from "../../Skeleton/orderConfirmationSkeleton";
import { scrollToTop } from "../../Layout/Common/common";

export const OrderStatusMain = () => {
  const { orderId } = useParams();
  const { userId } = useAuth();
  const [billInfo, setBillInfo] = useState(null);
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const globalcontext = useContext(GlobalContext);
  const { loadStoredCard, refreshCartItem } = useGlobalFunction();
  const { showFlashScreen } = useNoteAlert();
  const location = useLocation();
  const paymentData = location.state;

  useEffect(() => {
    scrollToTop();
    showFlashScreen(false);
    if (orderId) {
      setShowErrorMsg(false);
      axiosInstance
        .post("Shipping/GetBillInfo", {
          userId: String(userId),
          orderId: String(orderId),
        })
        .then((response) => {
          if (response.data && response.data.orderItem) {
            setBillInfo(response.data);
          } else {
            setShowErrorMsg(true);
          }
        })
        .catch((error) => {
          setShowErrorMsg(true);
        });
      loadStoredCard();
      refreshCartItem();
    }
  }, [orderId]);

  return (
    <Fragment>
      {showErrorMsg ? (
        <section className="checkoutOrder-section checkoutOrderSection">
          <div className="container-fluid container-lg">
            <div className="row">
              <div
                className="payaccount-empty text-center w-100 py-5 px-3"
                style={{ backgroundColor: "#fff", border: "none" }}
              >
                <svg
                  width="72"
                  height="72"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginBottom: 16 }}
                >
                  <circle cx="12" cy="12" r="10" fill="#ffffff" stroke="rgb(131 130 130)" strokeWidth="1.5" />
                  <line
                    x1="12"
                    y1="7"
                    x2="12"
                    y2="13"
                    stroke="rgb(131 130 130)"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                  <circle cx="12" cy="16.5" r="1.15" fill="rgb(131 130 130)" />
                </svg>
                <div className="payaccount-empty-text" style={{ color: "rgb(131 130 130)", fontSize: 18 }}>
                  Given reference id <b>#{orderId}</b> is invalid or does not exist.
                </div>
              </div>
            </div>
          </div>
        </section>
      ) : !billInfo ? (
        <OrderConfirmationSkeleton />
      ) : (
        <Fragment>
          <section className="checkout-orderCompleted checkoutOrdercompleted">
            <div className="container-fluid container-lg">
              <div className="row">
                <OrderStatusGreeting
                  reference={billInfo.poNumber}
                  orderStatus={billInfo.orderStatusId}
                  isTBA={billInfo.isTBA}
                />
              </div>
            </div>
          </section>
          <section className="checkoutOrder-section checkoutOrderSection">
            <div className="container-fluid container-lg">
              <div className="row">
                <div className="col-md-8 offset-md-2 checkout-left">
                  <div className="row">
                    <OrderStatusDetail billInfo={billInfo} />
                    <OrderSummaryMain billInfo={billInfo} />
                    {/* <div className="col-lg-12 checkout-button">
                      <Link to="/OrderDetails" className="return-to-cart d-none d-md-block">
                        <i className="fa-solid fa-chevron-left" /> Go to My Orders
                      </Link>
                      <div className="button-effect">
                        <Link to="/home" className="btn btn-products btn-addcart">
                          Continue Shopping
                        </Link>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Fragment>
      )}
    </Fragment>
  );
};
